if (!customElements.get("custom-swiper")) {
  class CustomSwiper extends HTMLElement {
    constructor() {
      super();

      this.sectionId = this.getAttribute("id");
      this.flickityOptions = JSON.parse(
        document.querySelector(`[id=SwiperOptions-${this.sectionId}]`)
          .innerHTML,
      );
      this.flickityOptions.draggable = true;

      this.flickityOptions.arrowShape = {
        x0: 10,
        x1: 60,
        y1: 50,
        x2: 65,
        y2: 45,
        x3: 20,
      };

      window.addEventListener(
        "resize",
        this.debounce(() => {
          this.flickity.resize();
          this.init();
        }, 250),
      );

      this.init();
    }

    debounce(fn, delay, atStart, guarantee) {
      var timeout;
      var args;
      var self;

      return function debounced() {
        self = this;
        args = Array.prototype.slice.call(arguments);

        if (timeout && (atStart || guarantee)) {
          return;
        } else if (!atStart) {
          clear();

          timeout = setTimeout(run, delay);
          return timeout;
        }

        timeout = setTimeout(clear, delay);
        fn.apply(self, args);

        function run() {
          clear();
          fn.apply(self, args);
        }

        function clear() {
          clearTimeout(timeout);
          timeout = null;
        }
      };
    }

    init() {
      // FIX 2: Safely destroy the old Flickity instance if it already exists
      if (this.flickity && typeof this.flickity.destroy === "function") {
        this.flickity.destroy();
      }

      this.flickity = new Flickity(this, this.flickityOptions);

      this.flickity.on("select", () => {
        this.updateNavigationState();
      });

      this.updateNavigationState();

      this.classList.add("slider-initialized");
      if (this.closest(".swiper--editors-pick")) {
        document.dispatchEvent(
          new CustomEvent("editors-pick-slider:init", { detail: { el: this } }),
        );
      }
      if (this.closest(".swiper--newest-stories")) {
        document.dispatchEvent(
          new CustomEvent("editors-pick-slider:init", { detail: { el: this } }),
        );
      }
    }

    updateNavigationState() {
      const flickity = this.flickity;

      if (
        !flickity?.slides.length ||
        !flickity.prevButton ||
        !flickity.nextButton
      ) {
        return;
      }

      const tolerance = 1;
      const currentTarget = flickity.selectedSlide.target;
      const firstTarget = flickity.slides[0].target;
      const lastTarget = flickity.slides[flickity.slides.length - 1].target;

      if (currentTarget <= firstTarget + tolerance) {
        flickity.prevButton.disable();
      } else {
        flickity.prevButton.enable();
      }

      if (currentTarget >= lastTarget - tolerance) {
        flickity.nextButton.disable();
      } else {
        flickity.nextButton.enable();
      }
    }
  }
  customElements.define("custom-swiper", CustomSwiper);
}
